import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { ErrorState } from '@tiendanube/components';

interface MessagesListErrorProps {
  onRetryError: () => void;
}

function MessagesListError({
  onRetryError,
}: MessagesListErrorProps): JSX.Element {
  const { t } = useTranslation(Domain.CUSTOMERS);
  return (
    <ErrorState
      title={t('messages.errorResults.title')}
      action={{
        children: t('messages.errorResults.action'),
        onClick: onRetryError,
      }}
    />
  );
}

export default MessagesListError;
